import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getWarehouseMpnInfo = createAsyncThunk('warehouse/getWarehouseMpnInfo',
  async (mpn, { rejectWithValue }) => {
    try {
      const { data } = await authGet(`/co/warehouse/${mpn}`);
      return data[0];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export const clearWarehouseMpnInfo = createAction('clearWarehouseMpnInfo');

export default getWarehouseMpnInfo;
